<template lang="pug">
  input(type="number", :value="value", @blur="submit", min="1", step="1", @keypress="isInteger($event)", :placeholder="value")
</template>

<script>
export default {
  name: 'Bag__QtyInput',
  props: ['value'],
  methods: {
    submit (event) {
      this.$emit('change', event.target.value)
    },
    isInteger: function (evt) {
      evt = (evt) || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      // enter
      if (charCode === 13) return this.$el.blur()
      // prevent dots
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        return evt.preventDefault()
      }
      return true
    }
  }
}
</script>

<style>
</style>
